import SocialMediaSharing from './social-media-sharing';
import FeedFilters from './feed-filters';
import ArticleAuthorsSlider from './article-authors-slider';
import PremiumContent from './premium-content';
import PremiumVideo from './premium-video';

export default [
  new FeedFilters('.js-feed-filters'),
  new PremiumContent(),
  new PremiumVideo(),
  new ArticleAuthorsSlider(),
  new SocialMediaSharing(),
];
